import { coinHold } from "./index";
import { coinHoldBootDefaults } from "./boot/bootDefaults";
import { launchGame } from "@slot/game-shell";

void launchGame(coinHold, import.meta.env, coinHoldBootDefaults);
